module.exports = __webpack_public_path__ + "static/media/barcelona_getty_mobile.b64f0ffe.jpg";